import axios from 'axios'
import { getToken } from '../geral'

export interface TrialSelfServiceOptions {
    sectors: string[]
    workers_counts: string[]
    job_positions: string[]
    job_occupations: string[]
}

/**
 * Obtém as opções de cadastro para o trial self-service.
 * Endpoint público: GET /trials/self-service/options/
 */
export const getTrialSelfServiceOptions =
    async (): Promise<TrialSelfServiceOptions> => {
        const response = await axios.get<TrialSelfServiceOptions>(
            `${process.env.NEXT_PUBLIC_BACKOFFICE_API}/trials/self-service/options/`
        )
        return response.data
    }

export interface CreateTrialSelfServicePayload {
    token: string
    full_name: string
    company_name: string
    company_workers_count: string
    sector: string
    job_occupation: string
    job_position: string
    phone: string
    products: string[]
    page_url: string
    form_id: string
    button_id: string
    label_text: string
    session_id: string
}

/**
 * Cria o cadastro de teste gratuito (trial) self-service para o JOTA PRO.
 * Endpoint público: POST /trials/self-service/
 *
 * @param {CreateTrialSelfServicePayload} data - Objeto contendo os dados do formulário de cadastro.
 * @return {Promise<unknown>} Retorna os dados da resposta da requisição.
 */
export const createTrialSelfService = async (
    data: CreateTrialSelfServicePayload
): Promise<unknown> => {
    const response = await axios.post(
        `${process.env.NEXT_PUBLIC_BACKOFFICE_API}/trials/self-service/`,
        data
    )
    return response.data
}

/**
 * Envia o interesse de um usuário trial self-service sobre o JOTA PRO.
 * Endpoint público: POST /trials/self-service/interest/
 *
 * @param {boolean} interested - Booleano indicando se o usuário tem interesse em continuar com JOTA PRO.
 * @return {Promise<void>} Retorna os dados da resposta da requisição.
 */
export const interestTrialSelfService = async (
    interested: boolean
): Promise<Response> => {
    const token = await getToken()
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKOFFICE_API}/trials/self-service/interest/`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ interested })
        }
    )

    return response
}
